<div class="date-picker-container" #datePicker>
    @if (isRange) {
        <ng-container [ngTemplateOutlet]="inputDouble"></ng-container>
        @if (rangeSelected?.start && rangeSelected?.end) {
            <div class="date-range-container" >
                <div class="range-selected">
                    <mat-icon class="material-icons calendar-icon">calendar_today</mat-icon>
                    <span>{{rangeSelected?.start | date}}</span>
                    <span>-</span>
                    <mat-icon inline="true" class="material-icons calendar-icon">calendar_today</mat-icon>
                    <span>{{rangeSelected?.end | date}}</span>
                    <mat-icon inline="true" class="material-icons filter-icon" role="button" (click)="clearDateRangeSelected()">close</mat-icon>
                </div>
            </div>
        }

    } @else {
        <ng-container [ngTemplateOutlet]="inputSingle" [ngTemplateOutletContext]="{dateString: selectedDateString, label: 'Fecha'}"></ng-container>
    }
    @if(hasInputError){
        <small class="help-text">{{ errorMessage }}</small>
    }


    @if (calendarType === DatePickerType.DOUBLE) {
        <ng-container [ngTemplateOutlet]="doubleCalendar"></ng-container>
    } @else {
        <ng-container [ngTemplateOutlet]="singleCalendar"></ng-container>
    }

</div>

<ng-template #singleCalendar>
    <div id="calendar" class="calendar" [class.calendar-range]="isRange" *ngIf="calendarVisible">
        <dian-date-picker-header
            (prevMonth)="prevMonth()"
            (nextMonth)="nextMonth()"
            (dropDownToggle)="headerDropdownToggle($event)"
            [currentMonth]="monthNames[currentMonth]"
            [currentYear]="currentYear"
            [type]="headerType">
        </dian-date-picker-header>
        @if (dayViewActive) {
            <ng-container>
                <hr class="calendar-divider"/>
                <ng-container [ngTemplateOutlet]="calendarBody"
                              [ngTemplateOutletContext]="{calendarDays: calendarDays}">
                </ng-container>

                <hr class="calendar-divider"/>
                <ng-container [ngTemplateOutlet]="actions"></ng-container>
            </ng-container>
        } @else {
            <ng-container>
                <!-- contenido alternativo -->
            </ng-container>
        }

    </div>
</ng-template>

<ng-template #doubleCalendar>
    @if(calendarVisible){
        <div class="calendar-double" [class.calendar-range]="isRange" >
            <div class="calendars" id="calendarDouble">
                <div class="calendars__body-container">
                    <div class="calendar-left">
                        <div class="calendar-header">
                            <button class="prev-month" (click)="prevMonth()"><mat-icon class="material-icons" inline="true">chevron_left</mat-icon></button>
                            <span class="month-year">{{ monthNames[currentMonth] }} {{ currentYear }}</span>
                        </div>
                        <hr class="horizontal-divider"/>
                        <ng-container [ngTemplateOutlet]="calendarBody" [ngTemplateOutletContext]="{calendarDays: calendarDays}"></ng-container>
                    </div>
                    <div class="calendar-right">
                        <div class="calendar-header">
                            <span class="month-year">{{ monthNames[currentMonth + 1 > 11 ? 0 : currentMonth + 1] }}</span>
                            <button class="next-month" (click)="nextMonth()"><mat-icon class="material-icons" inline="true">chevron_right</mat-icon></button>
                        </div>
                        <hr class="horizontal-divider"/>
                        <ng-container [ngTemplateOutlet]="calendarBody" [ngTemplateOutletContext]="{calendarDays: leftCalendarDays}"></ng-container>
                    </div>
                </div>
                <hr class="horizontal-divider"/>
                <ng-container [ngTemplateOutlet]="actions"></ng-container>
            </div>
        </div>
    }

</ng-template>

<ng-template #calendarBody let-calendarDays="calendarDays">
    <div class="calendar-body-container">
        <div class="calendar-body">
            <div class="calendar-weekdays">
                @for (day of weekdays; track $index) {
                    <div [attr.tabindex]="0" class="week-day">{{ day }}</div>
                }
            </div>
            <div class="calendar-days" #dayContainer>
                @for (day of calendarDays; track $count) {
                    <button
                        [class]="{
                            'neutral': day.neutral,
                            'selected': isSelectedDay(day.date),
                            'current': day.current,
                            'date-in-range': day.isDayInRange && !day.neutral,
                            'range-start': day.isRangeStart,
                            'range-end': day.isRangeEnd,
                            'active-event': day.hasActiveEvent}"
                        [class.calendar-range]="isRange"
                        (click)="selectDate(day.date)"
                        [disabled]="day.neutral"
                        [tabindex]="day.neutral ? -1 : 0"
                        (keydown)="handleKeydown($event, $index)">
                        <span>{{ day.date.getDate() }}</span>
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>

<ng-template #inputDouble>
    <div class="double-input-container">
        <ng-container [ngTemplateOutlet]="inputSingle" [ngTemplateOutletContext]="{dateString: selectedRangeStartDateString, label: 'Fecha inicio'}"></ng-container>
        <ng-container [ngTemplateOutlet]="inputSingle" [ngTemplateOutletContext]="{dateString: selectedRangeEndDateString, label: 'Fecha final'}"></ng-container>
    </div>
</ng-template>

<ng-template #inputSingle let-dateString="dateString" let-label="label">
    <div class="input-container">
        <!-- <label for="input-date-picker" class="input-label">
            {{label}}
            <mat-icon class="material-icons" inline="true">help</mat-icon>
        </label> -->
        <div class="input-wrapper">
            <input
                #dateInput textMask
                [readOnly]="isRange"
                id="input-date-picker"
                type="text"
                [value]="dateString"
                [disabled]="isDisabled"
                placeholder="DD-MM-AÑO"
                [class.invalid]="hasInputError"
                (input)="calendarVisible = false"
                (blur)="handleBlurEvent(); handleInputChange($event) "
                (change)="handleInputChange($event)">
            <mat-icon
                tabindex="0"
                class="material-icons calendar-icon"
                role="button"
                (keydown.enter)="toggleCalendar()"
                (click)="toggleCalendar()">calendar_today</mat-icon>
        </div>
    </div>
</ng-template>

<ng-template #actions>
    <div class="calendar-actions" [class.double]="calendarType === DatePickerType.DOUBLE">
        <dian-button
            type="secondary"
            label="Cancelar"
            (keydown.enter)="handleCancelEvent()"
            (click)="handleCancelEvent()"></dian-button>
        <dian-button
            label="Guardar"
            (keydown.enter)="handleSaveChangeEvent()"
            (click)="handleSaveChangeEvent()"
            [disabled]="isDisabledSaveButton"></dian-button>
    </div>
</ng-template>

<ng-template #monthYearView>
    <div class="calendar-body-container">
        @if (monthYearViewTarget === 'monthView') {
            <div class="months-view">
                @for (item of monthNames; track $index) {
                    <span role="button" tabindex="0" (keydown.enter)="setCurrentMonthByIndex($index)" (click)="setCurrentMonthByIndex($index)" class="month" [class.selected]="currentMonth === $index">{{item | slice: 0 : 3 }}</span>
                }
            </div>
        } @else if (monthYearViewTarget === 'yearView') {
            <div class="years-view">
                @for (item of yearsOptions; track $index) {
                    <span role="button" tabindex="0" (keydown.enter)="currentYear = item" (click)="currentYear = item" class="year" [class.selected]="currentYear === item">{{item}}</span>
                }
            </div>
        }
    </div>
    <div class="month-actions">
        <dian-button
            type="secondary"
            label="Cancelar"
            (keydown.enter)="closeMonthYearView(true)"
            (click)="closeMonthYearView(true)"></dian-button>
        <dian-button
            class="confirmation-btn"
            label="Guardar"
            (keydown.enter)="closeMonthYearView()"
            (click)="closeMonthYearView()"></dian-button>
    </div>
</ng-template>
